export default "__VITE_ASSET__CK21DGZ6__"